import { Handle, Position } from '@xyflow/react'
import { INodeDescription } from '../../../definitions/NodesDescription'
import { NodeType } from '../../../definitions/Nodes'

interface P<T extends NodeType> {
    output: INodeDescription<T>['outputs'][0]
    outputsCount: number
    index: number
}

function CustomOutputHandle<T extends NodeType>({ output, outputsCount, index }: P<T>) {
    if (!output) return null

    const { key } = output
    const range = 100
    const interval = range / (outputsCount + 1)
    const left = interval * (index + 1) + '%'
    return (
        <Handle
            type='source'
            id={String(key)}
            position={Position.Bottom}
            style={{ left: left }}>
            <div className='handle-label'>
                <div className='handle-label-text1'>
                    {key.toString()[0]}
                </div>
                <div className='handle-label-text2'>
                    {key.toString()}
                </div>
            </div>
        </Handle>
    )
}

export default CustomOutputHandle
